module.exports = __webpack_public_path__ + "img/icon1.95262863.png";